const validateVatId = (value) => {
    let maxLen = 8; 

    if (value.length < 8) {
        return false;
    }

    let intValue = parseInt(value), maxDavcna = Math.pow(10, maxLen) - 1;
    if (isNaN(intValue)) {
        return false;
    }

    if (intValue > maxDavcna) {
        return false;
    }

    // Value format.
    let tabelaDavcna = [];
    for (let i = (maxLen - 1); i >= 0; i--) {
        tabelaDavcna[i] = intValue % 10;
        intValue -= tabelaDavcna[i];
        intValue /= 10;
    }

    let sestevekZmnozkov = 0;
    for (let pos = 0; pos < maxLen - 1; pos++) {
        sestevekZmnozkov = (maxLen - pos) * tabelaDavcna[pos] + sestevekZmnozkov;
    }

    let ostanekPriDeljenju = sestevekZmnozkov % 11;
    let kontrolnaStevilka = 11 - ostanekPriDeljenju;
    if (kontrolnaStevilka == 10) {
        kontrolnaStevilka = 0;
    }
    else if (kontrolnaStevilka == 11) {
        // invalid kontrolna stevilka
        return false;
    }

    if (kontrolnaStevilka != tabelaDavcna[maxLen - 1]) {
        // invalid kontrolna stevilka
        return false;
    }

    return true;
};


module.exports = {
    validateVatId
};